
import React from 'react';
import './MissionVision.css';


const DotPatternSVG = () => (
    <svg width="180" height="40" viewBox="0 0 180 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="dot-svg">
        {[...Array(9)].map((_, i) => (
            <circle key={i} cx={20 * i + 10} cy="20" r="4" fill="#1995A2" opacity="0.3" />
        ))}
    </svg>
);

const MissionVision = () => {
    return (
        <section className="mission-vision-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-8 mb-5 mb-lg-0">
                        <div className="mv-card vision-card text-center p-4 h-100">
                            <div className="mv-icon mb-3" aria-hidden="true">
                                <span role="img" aria-label="Vision" style={{fontSize: '2.5rem', color: '#1995A2'}}>&#128161;</span>
                            </div>
                            <h2 className="mv-title">Our Vision</h2>
                            <div className="vision-statement">
                                <p className="mv-statement">To reimagine how the world works.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1 d-none d-lg-flex align-items-center justify-content-center">
                        <DotPatternSVG />
                    </div>
                    <div className="col-lg-5 col-md-8">
                        <div className="mv-card mission-card text-center p-4 h-100">
                            <div className="mv-icon mb-3" aria-hidden="true">
                                <span role="img" aria-label="Mission" style={{fontSize: '2.5rem', color: '#1995A2'}}>&#128640;</span>
                            </div>
                            <h2 className="mv-title">Our Mission</h2>
                            <div className="mission-statement">
                                <p className="mv-statement">To connect the dots between impactful jobs and great global hires.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MissionVision;